import { useItineraryLabelStore } from '@ops/shared/model';
import { useEffect } from 'react';
import { trpc } from '@/shared/api/trpc';

// Resolve URL-supplied itinerary IDs that miss the in-memory label cache
// back to human-readable labels, then warm the cache. Without this, a cold
// start (reload, shared link, back/forward) renders the toolbar chip as a
// raw UUID because the URL only carries IDs. Only misses are fetched, so a
// warm cache (freshly picked from the autocomplete) issues no request.
export const useHydrateItineraryLabels = (ids: readonly string[]) => {
  const cached = useItineraryLabelStore((s) => s.byId);
  const cacheMany = useItineraryLabelStore((s) => s.cacheMany);

  const missing = ids.filter((id) => !cached.has(id));

  const { data } = trpc.operations.itinerariesByIds.useQuery(
    { ids: missing },
    { enabled: missing.length > 0, staleTime: 30_000 }
  );

  useEffect(() => {
    if (data && data.length > 0) cacheMany(data);
  }, [data, cacheMany]);
};
